import React from "react";

import styled from "styled-components/macro";

export default function PublicSignupNotFound() {
  return (
    <Wrapper>
      <Title>Oh no!</Title>

      <Text>
        This Signup is not available. Please check with the sender of this
        Signup link to make sure they sent the correct one.
      </Text>

      <Img src="https://dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg" />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  padding: 100px 20px;
`;

const Title = styled.h1`
  font-weight: 900;
  font-size: 72px;
  color: #ccc;
`;

const Text = styled.div`
  color: #222;
  line-height: 1.5;
  font-weight: 400;
  font-size: 18px;
  margin-top: 30px;
  margin-bottom: 80px;
`;

const Img = styled.img`
  display: block;
  border-radius: 100%;
  margin: 0 auto;
  height: 54px;
  width: 54px;
`;
